$(document).ready(function () {
  $('.jdgm-carousel-wrapper .jdgm-carousel-item').each(function () {
    $(this).find('.jdgm-carousel-item__reviewer-name-wrapper .jdgm-carousel-item__reviewer-name').appendTo($(this).find('.jdgm-carousel-item__review'))
  })
  $('.home-our-story button.play-video').click(function () {
    $('.home-our-story .lazyframe.lazyframe--embedded-video.lazyframe--loaded').css('z-index', '1')
  });

  $('.our-product .text-custom .box').css('height', $('.our-product .column.product .first-image').height());
  $(window).resize(function () {
    $('.our-product .text-custom .box').css('height', $('.our-product .column.product .first-image').height());
  });
  $('.icon-and-text-large-section .int-item-image img').matchHeight();
  $('.jdgm-carousel-item__review-body').matchHeight();
  $('.template-collection .collection-product-inner').matchHeight();
  $('.text-and-image-slider-section .tni-slider-images-section').matchHeight();

  function resizedw() {
    $('.our-product .text-custom .box').matchHeight();
  }
  var doit;
  window.onresize = function () {
    clearTimeout(doit);
    doit = setTimeout(resizedw, 100);
  };


  if ($(window).width() > 799) {
    $(document).click(function (e) {
      var container = $('.theme-header-block.site-header__search .icon');
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.theme-header-block.site-header__search #FormSearch').fadeOut(200);
      }
    });
  }


  //   limit text
  $.fn.limit = function ($n) {
    this.each(function () {
      var allText = $(this).html();
      var tLength = $(this).html().length;
      var startText = allText.slice(0, $n);
      if (tLength >= $n) {
        $(this).html(startText + '...');
      } else {
        $(this).html(startText);
      };
    });

    return this;
  }
  $('.home-review-section .jdgm-carousel-wrapper .jdgm-carousel-item__review-body.jdgm-line-clamp p').limit(70);
  $('.home-review-section .jdgm-carousel-item__review-body p').limit(70);
  if ($(window).width() < 767.98) {
    $('.home-review-section .jdgm-carousel-wrapper .jdgm-carousel-item__review-body.jdgm-line-clamp p').limit(50);
    $('.home-review-section .jdgm-carousel-item__review-body p').limit(50);
  }
  if ($(window).width() > 1500) {
    $('.review-container').addClass('container l');
  }

  if ($('.container.slide')) {
    $('.container.slide .row').addClass('swiper-wrapper');
    $('.container.slide .row .item').addClass('swiper-slide');
    $('.container.slide').addClass('swiper-product');
    var swiper = new Swiper(".swiper-product", {
      allowTouchMove: false,
      pagination: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
          allowTouchMove: true,
          spaceBetween: 35,
        },
        400: {
          slidesPerView: 2,
          allowTouchMove: true,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 3,
          allowTouchMove: false,
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 5,
          allowTouchMove: false,
          spaceBetween: 0,
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + '</span>';
        },
      }
    });
  }
})
